<div class="flex flex-row justify-between">
  <p-breadcrumb [model]="[]" [home]="home" />
</div>

<div class="card p-3 mt-3">
  <h3 class="m-0 mb-3">PDF hochladen</h3>
  <div class="flex gap-2 items-center flex-wrap">
    <input
      #pdfFileInput
      type="file"
      accept="application/pdf"
      (change)="onFileChange($event)"
      class="hidden-file-input"
    />
    <p-button
      label="Datei auswählen"
      icon="pi pi-file-pdf"
      severity="secondary"
      [outlined]="true"
      [disabled]="isUploading"
      (onClick)="pdfFileInput.click()"
    />
    <p-button
      label="Upload starten"
      icon="pi pi-upload"
      [loading]="isUploading"
      [disabled]="!selectedFile || isUploading"
      (onClick)="uploadPdf()"
    />
    @if (selectedFile) {
      <span class="selected-file-name">{{ selectedFile.name }}</span>
    } @else {
      <span class="selected-file-placeholder">Keine Datei ausgewaehlt</span>
    }
  </div>
  <p-message severity="info" styleClass="mt-3" text="Extraktion der Inhalte, danach automatische Kapitel-/Chunk-Verarbeitung." />
  @if (isUploading) {
    <div class="upload-progress mt-3">
      <div class="upload-progress-header">
        <span>{{ uploadProgressMessage || 'Upload laeuft' }}</span>
        <span>{{ uploadProgressPercent }}%</span>
      </div>
      <div class="upload-progress-bar">
        <div class="upload-progress-fill" [style.width.%]="uploadProgressPercent"></div>
      </div>
    </div>
  }
</div>

<div class="card p-3 mt-3">
  <h3 class="m-0 mb-3">PDF-Dokumente verwalten</h3>
  <p-table [value]="documents" [tableStyle]="{ 'min-width': '50rem' }" showGridlines>
    <ng-template #header>
      <tr>
        <th>Name</th>
        <th>Status</th>
        <th>Seiten</th>
        <th>Upload</th>
        <th class="text-right">Aktionen</th>
      </tr>
    </ng-template>
    <ng-template #body let-doc>
      <tr>
        <td>
          @if (this.editingDocumentId === doc._id) {
            <div class="flex gap-2 items-center">
              <input
                type="text"
                [(ngModel)]="editingNameForUser"
                pInputText
                class="w-full"
                placeholder="Dokumentname"
              />
            </div>
          } @else {
            <div class="flex flex-col">
              <span class="font-semibold">{{ doc.nameForUser || doc.name }}</span>
              <span class="text-xs text-gray-400">{{ doc.name }}</span>
            </div>
          }
        </td>
        <td>{{ doc.status }}</td>
        <td>{{ doc.metadata?.totalPages ?? '-' }}</td>
        <td>{{ doc.uploadedAt | date:'dd.MM.yyyy HH:mm' }}</td>
        <td class="text-right">
          <div class="flex gap-2 justify-end">
            @if (this.editingDocumentId === doc._id) {
              <p-button
                icon="pi pi-check"
                severity="success"
                [text]="true"
                [loading]="isSavingDocumentName"
                [disabled]="isSavingDocumentName"
                pTooltip="Speichern"
                tooltipPosition="top"
                (onClick)="saveDocumentName(doc)"
              />
              <p-button
                icon="pi pi-times"
                severity="secondary"
                [text]="true"
                [disabled]="isSavingDocumentName"
                pTooltip="Abbrechen"
                tooltipPosition="top"
                (onClick)="cancelEditingDocument()"
              />
            } @else {
              <p-button
                icon="pi pi-pencil"
                severity="secondary"
                [text]="true"
                pTooltip="Bearbeiten"
                tooltipPosition="top"
                (onClick)="startEditingDocumentName(doc)"
              />
              <p-button
                label="Details"
                icon="pi pi-info-circle"
                severity="secondary"
                [text]="true"
                (onClick)="showDetails(doc)"
              />
              <p-button
                label="Loeschen"
                icon="pi pi-trash"
                severity="danger"
                [text]="true"
                (onClick)="deleteDocument(doc)"
              />
            }
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  [header]="'Dokumentdetails - ' + selectedDocumentName"
  [(visible)]="chaptersDialogVisible"
  [modal]="true"
  [style]="{ width: '72rem' }"
>
  @if (loadingChapters) {
    <p>Lade Details ...</p>
  } @else {
    <p-tabs value="0">
      <p-tablist>
        <p-tab value="0">Kapitel</p-tab>
        <p-tab value="1">Extrahierte Chunks</p-tab>
        <p-tab value="2">Verwendet in Fallaufgaben-Versionen</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <p-table [value]="selectedDocumentChapters" showGridlines class="mt-2">
            <ng-template #header>
              <tr>
                <th>#</th>
                <th>Titel</th>
                <th>Seiten</th>
                <th>Tags</th>
              </tr>
            </ng-template>
            <ng-template #body let-ch>
              <tr>
                <td>{{ ch.chapterNumber }}</td>
                <td>{{ ch.title }}</td>
                <td>{{ ch.pageRange.start }} - {{ ch.pageRange.end }}</td>
                <td>{{ (ch.tags || []).join(', ') }}</td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr>
                <td colspan="4">Keine Kapitel vorhanden.</td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabpanel>
        <p-tabpanel value="1">
          <p-table [value]="selectedDocumentChunks" showGridlines class="mt-2">
            <ng-template #header>
              <tr>
                <th style="width:4rem">#</th>
                <th style="width:8rem">Seiten</th>
                <th>Inhalt</th>
              </tr>
            </ng-template>
            <ng-template #body let-chunk>
              <tr>
                <td>{{ chunk.sequenceNum }}</td>
                <td>{{ chunk.pageStart }}{{ chunk.pageStart !== chunk.pageEnd ? ' - ' + chunk.pageEnd : '' }}</td>
                <td style="white-space:pre-wrap;word-break:break-word">{{ chunk.content }}</td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr>
                <td colspan="3">Keine Chunks vorhanden.</td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabpanel>
        <p-tabpanel value="2">
          <p-table [value]="selectedDocumentUsages" showGridlines class="mt-2">
            <ng-template #header>
              <tr>
                <th>Name</th>
                <th>Version</th>
                <th>Status</th>
                <th>Typ</th>
              </tr>
            </ng-template>
            <ng-template #body let-usage>
              <tr>
                <td>{{ usage.name }}</td>
                <td>v{{ usage.version }}</td>
                <td>{{ usage.state }}</td>
                <td>{{ usage.type }}</td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr>
                <td colspan="4">Dieses Dokument wird aktuell in keiner Fallaufgabe verwendet.</td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  }
</p-dialog>
